<template>
  <div v-show="!hidden" class="table-menu"     
    @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')"
    @wheel.stop>  
    <!-- 关闭按钮 -->
    <div @mousedown="startDrag" >
      <button class="close-button" @click="$emit('closeTableMenu')">×</button>
      <!-- 表格标题 -->
      <h2 class="table-title">{{ tableData.title }}</h2>      
    </div>
    
    <div class="table-full-scroll-container">
      <table>
        <!-- <colgroup>
           前两列添加固定类 
          <col class="sticky-column">
          <template v-if="tableData.data.length > 0">
            <col :class="{'sticky-column':colindex < 1}" v-for="(col, colindex) in tableData.columnHeaders.columns" :key="colindex">
          </template>
          <col v-if="tableData.level === 0">
          <col v-else-if="tableData.level === 1">
          <col v-else-if="tableData.level === 2">
        </colgroup> -->
        <thead class="table-header">
          <!-- 动态生成表头 -->
          <template v-if="tableData.data.length > 0">
            <tr>
              <!-- 前两列 th 添加固定类 -->
              <th class="sticky-column-header">{{ tableData.columnHeaders.firstColumnTitle }}</th>              
              <th :class="{'sticky-column-header-2':colindex<1}" v-for="(col, colindex) in tableData.columnHeaders.columns" :key="colindex">{{ col.label }}</th>
              <th v-if="tableData.level === 0" >{{ tableData.columnHeaders.lastColumnTitle }}</th>
              <th v-else-if="tableData.level === 1" >{{ tableData.columnHeaders.lastColumnTitle }}</th>
              <th v-else-if="tableData.level === 2" >{{ tableData.columnHeaders.lastColumnTitle }}</th>
            </tr>
          </template>
          <tr v-else>
            <th colspan="2">{{ tableData.message }}</th>
          </tr>
        </thead>
        <tbody class="table-body">
          <!-- 循环渲染表格数据 -->
          <template v-if="tableData.data.length > 0">
            <tr
              v-for="(row, rowIndex) in tableData.data"
              :key="rowIndex"
              @mouseover="highlightRow(rowIndex)"
              @mouseout="unhighlightRow(rowIndex)"
              :class="{ 'highlight': highlightedRow === rowIndex }"
            >
              <!-- 前两列 td 添加固定类 -->
              <td class="sticky-column" :class="{ 'highlight': highlightedRow === rowIndex }">{{ rowIndex + 1 }}</td>             
              <td :class="{[colindex< 1?'sticky-column-2':'normal-cell']:true,'highlight': highlightedRow === rowIndex}" v-for="(col, colindex) in tableData.columnHeaders.columns" :key="colindex">{{ typeof row[col.name] === 'number'? (Number.isInteger(row[col.name])? row[col.name] : row[col.name].toFixed(2)):(col.name == 'SHZT'?shztToString(row[col.name]):row[col.name])}}</td>
              <td v-if="tableData.level === 0"><a @click="$emit('clickDistrictByName',{WYBH:row['ZJ']});$emit('closeTableMenu')">查看详情</a></td>
              <td v-else-if="tableData.level === 1">
                <a @click="$emit('secondSetlectPatchesByZJ', { TCMC: tableData.TCMC, ZJ: row['ZJ'] })">查看详情</a><br>
              </td>
              <td v-else-if="tableData.level === 2">
                <a @click="$emit('positionToPatch', { WYBH: row['WYBH'], TCMC: tableData.TCMC })">定位</a><br>                
                <a @click="$emit('getPatchPhotoData', {TCMC:tableData.TCMC,TCJC:'查看照片',WYBH:row['WYBH']})">查看照片</a><br>
                <a v-if="row['YJFL'] && row['SHBH']" @click="$emit('executeSHByCode', {code:'CKSQ',TCMC:tableData.TCMC,WYBH:row['SHBH']})">查看申请</a>
                <a v-else-if="row['YJFL']" @click="$emit('executeSHByCode', {code:'TJSQ',TCMC:tableData.TCMC,WYBH:row['WYBH']})">提交申请</a>

              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>    
</template>

<script>


// 脚本部分保持不变
export default {
  name: 'TableMenu',
  props: {
    tableData: {
      type: Object,
      default: null,
    },
    hidden: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      highlightedRow: null,
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
    };
  },
  methods: {
    highlightRow(index) {
      this.highlightedRow = index;
    },
    unhighlightRow() {
      this.highlightedRow = null;
    },
    startDrag(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      if (this.$el) {
        this.offsetX = this.$el.offsetLeft;
        this.offsetY = this.$el.offsetTop;        
        document.addEventListener('mousemove', this.drag);
        document.addEventListener('mouseup', this.stopDrag);
      }
    },
    drag(event) {
      event.stopPropagation();
      if (this.isDragging && this.$el) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        if (this.$el.style) {
          this.$el.style.left = `${this.offsetX + dx}px`;
          this.$el.style.top = `${this.offsetY + dy}px`;
        }
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    shztToString(shzt){
      switch(shzt){
        case '审核中':
          return '待反馈';
        case '已通过':
          return '已反馈';
        case '未通过':
          return '需整改';
        default:
          return shzt;
      } 
    },
  }
};
</script>

<style scoped>
.table-menu {
  width: 60%;
  top: 20vh;   
  left: 450px;
  max-height: 50vh;
  /* 移除水平滚动条 */  
  position: fixed;
  z-index: 1002;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
  padding: 10px;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1004;
}

.table-title {
  background-color: #e0e0e0; /* 标题栏背景颜色 */
  padding: 5px;
  margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  position:relative;
  top:0;
  z-index: 1003;
}

.table-full-scroll-container {
  overflow: auto;
  width: fit-content;
  max-width: 100%;
  max-height: 45vh;
  scrollbar-width: thin;
  min-width: 100%;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: auto;
}

/* 设置固定列样式 */
.sticky-column {
  position: sticky;
  left: 0;
  background-color: #fff;
  z-index: 1006; /* 设置 z-index，确保固定列显示在其他列之上 */
  border: 1px solid #ccc; /* 添加水平表格边框 */
}

.sticky-column-2 {
  position: sticky;
  left: 84px;
  background-color: #fff;
  z-index: 1006; /* 设置 z-index，确保固定列显示在其他列之上 */
  border: 1px solid #ccc; /* 添加水平表格边框 */
}

.sticky-column-header {
  position: sticky;
  left: 0;
  top:0;
  background-color: white; /* 设置背景颜色，避免滚动时透明 */
  z-index: 1010; /* 设置 z-index，确保固定列显示在其他列之上 */
}

.sticky-column-header-2 {
  position: sticky;
  left: 84px;
  top:0;
  background-color: white; /* 设置背景颜色，避免滚动时透明 */
  z-index: 1010; /* 设置 z-index，确保固定列显示在其他列之上 */
}


/* 设置标题行和前两行固定样式 */
.sticky-top {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1008;
  border: 1px solid #ccc; /* 添加水平表格边框 */
}

.normal-cell{
  border: 1px solid #ccc;
  background-color: #f0f0f0;
}

.table-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1005;
  border: 1px solid #ccc; /* 添加水平表格边框 */
}

th, td {
  margin: 0; 
  border: 1px solid #ccc;
  font: inherit;
  vertical-align:middle;
  white-space: normal;
  min-width:  80px;
  padding: 5px; 
}

.highlight {
  background-color: rgb(149, 149, 196);
  cursor: pointer;
  opacity: 0.9;
  color:white;
  z-index: 1011;
}

</style>
